function OtaUpdateBanner() {
  return null;
}

export default OtaUpdateBanner;
